import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConsultantFormComponent } from 'src/app/WebView/FormWebView/query/consultant-form/consultant-form.component';
import { APISchedulerService } from 'src/services/api-services/api-scheduler-service';

import { TranslateService } from '@ngx-translate/core';
import { GetAppointmentCreate } from 'src/services/incadea/incadea-services/getAppointmentCreate.service';
import { tap } from 'rxjs';
import { GetTokenService } from 'src/services/incadea/incadea-services/getToken.service';
import { IncadeaAppointment } from 'src/services/api-services/api-interfaces/IBAppointmentGET.interface';
import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';

 

@Component({
    selector: 'app-i-cancel-appointment',
    templateUrl: './i-cancel-appointment.component.html',
    styleUrls: ['./i-cancel-appointment.component.sass'],
    standalone: false
})
export class ICancelAppointmentComponent implements OnInit {

  public showMessageNotFound: boolean = false;
   public YourReservationHasNeenCanceled:string=""
   recievedLanguageForCountry:any = history.state.LanguageForCountry as {}
   recievedTokenIncadea: any = history.state.tokenIncadea as {}
   isDeleting = false;

  constructor(
    public dialogRef: MatDialogRef <ConsultantFormComponent>,
      @Inject (MAT_DIALOG_DATA) 
      public recivedData:any,
      public schedulerService: APISchedulerService, 
    
      private translate: TranslateService,
      public getAppointmentCancel: GetAppointmentCreate,
      public cancelAppointmentSchedule: IncadeaBookingService,
      
      
      
      
  ) { }

  schedule

  ngOnInit(): void {
    // console.log(this.recivedData.scheduleId.BackEndCode,this.recivedData)
    this.evaluateLanguage();
    // this.schedulerService.get(this.recivedData.scheduleId).pipe (tap((Response)=>{this.schedule = Response})).subscribe()
       this.YourReservationHasNeenCanceled= this.translate.instant('YourReservationHasNeenCanceled'); 
 }

 deleteServiceSchedule() {
    this.isDeleting = true
    // console.log(this.recivedData.scheduleId.BackEndCode,this.recivedData)
    this.getAppointmentCancel.cancelAppointmnet(this.recivedData.recievedTokenIncadea,this.recivedData.scheduleId.CompanyId,this.recivedData.scheduleId.AppointmentId,this.recivedData.BackEndCode).subscribe(
     {next:(response) => {

      
        if (response.status === 200) {
          
          this.cancelAppointmentSchedule.cancelAppointment(this.recivedData.scheduleId.AppointmentId).subscribe(
            {
              next:(response) => {

   console.log(response)
        if (response.code === 200) {
          
         
                if (response.message=== "Deleted successfully") {
                 
                  this.dialogRef.close('eliminado')
  
                }
             
        }
        if (response.code === 400 || response.code === 500) {
            
          console.error("Error al cancelar la cita", response);
          
        }
        
      }
            }
          )
        }
        if (response.status === 400 || response.status === 500) {
            
          console.error("Error al cancelar la cita", response);
          
        }
        
      },error: (failed) => {
        
        if(failed.error.Detail ==="The appointment has already been canceled"){
          this.cancelAppointmentSchedule.cancelAppointment(this.recivedData.scheduleId.AppointmentId).subscribe(
            {next:(response) => {

   
        if (response.code === 200) {
          
         
                if (response.message=== "Deleted successfully") {
                 
                  this.dialogRef.close('eliminado')
  
                }
             
        }
        if (response.code === 400 || response.code === 500) {
            
          console.error("Error al cancelar la cita", response);
          
        }
        
      }

              
              // error: (failed) => {
              //   console.log(failed,failed.error.text)
              //   let mensageError = failed.error.text;
              //   if (mensageError === "Deleted successfully") {
                 
              //     this.dialogRef.close('eliminado')
  
              //   }
              // },
            }
          )
        }
        else{
          console.error("Error al cancelar",failed)
          this.dialogRef.close('No eliminado')
        }

      
      }
      
    }
    ) 
 }
 cancel(){
  this.dialogRef.close()
 }
 evaluateLanguage(): void {
 }

}
